<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  import Navbar from '@/components/navbar/navbar'

  export default {
    name: 'About',
    components: {Navbar}
  }
</script>



// WEBPACK FOOTER //
// about.vue?f84f60da